import { wsService } from '@/processes/WsService/model';
import { RouterProvider } from 'react-router';

import { ModalSystem } from '@/shared/lib';
import { Toaster } from '@/shared/ui';

import ErrorBoundaryProvider from './providers/ErrorBoundaryProvider';
import QueryProvider from './providers/QueryProvider';
import { router } from './router';
import './styles/index.css';

const App = () => {
  window.addEventListener('beforeunload', () => {
    wsService.client?.closeSocket();
  });
  return (
    <QueryProvider>
      <ErrorBoundaryProvider>
        <RouterProvider router={router} />
        <ModalSystem />
        <Toaster />
      </ErrorBoundaryProvider>
    </QueryProvider>
  );
};

export default App;
